import Image from 'next/image'
import { StaticImageData } from 'next/image'
import type { ReactNode } from 'react'

interface CustomButtonProps {
  children?: ReactNode
  name?: ReactNode
  onClick?: () => void
  className?: string
  imageSrc?: string | StaticImageData | null
  imageAlt?: string
  ButtonBgColor?: string
  disabled?: boolean
}

export function CustomFilterFlagButton ({
  children,
  name,
  onClick,
  className,
  imageSrc,
  imageAlt,
  ButtonBgColor,
  disabled = false,
}: CustomButtonProps){
  const buttonContent = children ?? name

  return (
    <button
      type='button'
      onClick={onClick}
      disabled={disabled}
      className={`
        ${className}    
        w-auto
        min-w-fit
        h-[37px] 
        opacity-100 
        rounded-lg 
        pt-2 
        pb-2 
        pr-[7px]
        pl-[7px] 
        gap-2 
        bg-gray-100 
        flex 
        items-center 
        justify-start
        transition-none 
        duration-0
        ${disabled ? 'cursor-default' : 'cursor-pointer'}
      `}
      aria-label={typeof buttonContent === 'string' ? buttonContent : undefined}
      style={{
        animationDuration: '0ms',
        ...(ButtonBgColor ? { backgroundColor: ButtonBgColor } : {}),
      }}
    >
      {imageSrc ? (
        <Image
          src={imageSrc}
          alt={imageAlt || (typeof buttonContent === 'string' ? buttonContent : 'Filter icon')}
          className='opacity-100 relative rounded-full overflow-hidden object-contain flex-shrink-0'
          width={28}
          height={21}
          style={{
            width: '27.89px',
            height: '20.92px',
            top: '0.08px',
          }}
        />
      ) : null}

      <span className='
        flex-1
        h-[19px] 
        opacity-100 
        font-medium 
        text-xs 
        leading-[160%] 
        text-gray-900
        text-left
        whitespace-nowrap
      '>
        {buttonContent}
      </span>
    </button>
  )
}


